import { MM } from "@pdfking/quantity"

// Laid out and stretched apart, a piece's edge and the page's may differ a
// hair
export const EDGE = MM(0.1)

// The least a book's text and its cover's keep off every edge of the page,
// whatever security the job gives
export const MIN_BOOK_SECURITY = MM(15)
